import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { AppDashboardRoutingService } from './app-dashboard-routing.service';

@Injectable({ providedIn: 'root' })
export class AppDashboardRootGuard implements CanActivate {
    constructor(
        private _router: Router,
        private _appDashboardRoutingService: AppDashboardRoutingService
    ) {}

    public canActivate(
        _route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        return this._appDashboardRoutingService.getDashboardRootUrl(state.url).then((rootUrl) => {
            if (state.url.indexOf(rootUrl) === 0) {
                return true;
            }
            return this._router.parseUrl(rootUrl);
        });
    }
}
